import React, { Fragment, useContext, useState } from "react";
// Provider
import { AppContext } from "../../components/AppProvider";

// Utils

// UI
import { Container, openLayerFn } from "../Layout";

import { ConfirmLayer } from "../../components/UI/Dialog";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg } = useContext(AppContext);

  useTitle("마이페이지_설정_개인데이터삭제");

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleConfirmDialog = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".confirm-layer"));
  };

  const handleCancelCB = () => {
    // closeLayerFn($(".confirm-layer"));
  };

  const handleConfirmCB = () => {
    // closeLayerFn($(".confirm-layer"));
  };
  // 다이얼로그 ]]

  // useEffect(() => {
  // })

  return (
    <Fragment>
      <Container
        Title={"개인데이터 삭제"}
        dark={"dark"}
        isMain={false} /*bottom={list.length === 0 ? <Bottom /> : null}*/
      >
        <div className="contents">
          <div className="sub-contents">
            <div className="device-link-contain type3">
              <div>
                <p className="t-txt">
                  본 서비스와 연관된 개인 데이터를 삭제 할 수 있습니다.
                  <br />
                  삭제시 이용자가 서비스 사용시 저장된 개인데이터가 삭제되거나
                  익명으로 처리됩니다.
                  <br />
                  단, 법에 의해 데이터의 지속적인 보존이 필요한 경우
                  <br />
                  일부 데이터가 삭제되지 않으며, 보존기간이 지난경우
                  개인데이터는 즉시 삭제 됩니다.
                </p>
              </div>
              <div>
                <div className="round-list">
                  <div className="btn">
                    <a
                      href={void 0}
                      className="linebox btn-open-delete-cancle"
                      onClick={e =>
                        handleConfirmDialog(
                          "삭제",
                          "개인데이터를 삭제 하겠습니까?",
                          ""
                        )
                      }>
                      삭제
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      <ConfirmLayer
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleCancelCB}
        handleConfirmCB={handleConfirmCB}
      />
    </Fragment>
  );
};
